import React from 'react';
import {
    Stepper,
    Step,
    StepLabel,
    StepConnector,
    stepConnectorClasses,
    styled,
    Typography,
    Box,
} from '@mui/material';

const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 12,
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: "'rgba(255, 0, 0, 0.2)'",
        borderTopWidth: 3,
    },
}));
type QuestionDetails = { id: number 
    points:string
};

const StepperWithPoints = ({
  activeStep,
  questionsdetails,
  questionstab,
  setquestionstab
}: {
  activeStep: number;
 questionsdetails: QuestionDetails[];
  questionstab: number;
  setquestionstab: React.Dispatch<React.SetStateAction<number>>;
}) => {
const steps = questionsdetails.map((item, index) => ({
  label: `Question ${item.id}`,
  points: item.points,
  id:item.id
  
}));

console.log(steps, "88888++++++++8777777777")
console.log(questionsdetails, "questionsdetailsssssse444")
console.log(activeStep, "activeStep8899999999")
    return (
        <>
            <style>{`
        .custom-step-icon.Mui-active {
          color: #C8172F !important;
        }
      `}</style>

            <Box sx={{ width: '100%' }}>
                <Stepper activeStep={activeStep} alternativeLabel connector={<CustomConnector />}>
                    {steps.map((step, index) => (
                        <Step key={step.label}>
                            <StepLabel
                                StepIconProps={{
                                    className: 'custom-step-icon',
                                }}
                            >
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="body2">{step.label}</Typography>
                                    <Typography
                                        variant="body2"
                                        fontWeight={activeStep === step.id ? 700 : 400}
                                        color={activeStep === index ? '#C8172F' : '#696A6B'}
                                    >
                                        {step.points} pts
                                    </Typography>
                                </Box>
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
        </>
    );
};

export default StepperWithPoints;
